import { formatPastRelativeDateTime, OwaDate, owaDate } from 'owa-datetime';
import loc, { format } from 'owa-localize';
import { observableNow } from 'owa-observable-datetime';
import HtmlSanitizer from 'roosterjs-editor-dom/lib/htmlSanitizer/HtmlSanitizer';

import { SonoraStickyNotesLastModifiedTimeLabel } from '../SonoraItemResults.locstring.json';
import type { SonoraStickyNotes } from 'owa-editor-sonora-types';

export const getPrimaryTextForSonoraResultsStickyNotesItems = (
    sonoraItem: SonoraStickyNotes
): string => {
    return sonoraItem.bodyPreview;
};

export const getSecondaryTextForSonoraResultsStickyNotesItems = (
    sonoraItem: SonoraStickyNotes
): string => {
    return getModifiedTime(sonoraItem);
};

export const getTooltipStringForSonoraResultsStickyNotesItems = (
    sonoraItem: SonoraStickyNotes
): string => {
    const tooltipString: string = [sonoraItem.bodyPreview, getModifiedTime(sonoraItem)]
        .filter(str => str)
        .join('\n');

    return tooltipString;
};

export const insertStickyNotesSuggestionsIntoComposeEditor = (
    sonoraItem: SonoraStickyNotes,
    insertNodeCallback: (nodeToInsert: HTMLElement) => void
): void => {
    // Use white-space: pre to preserve white space and newlines from sticky note.
    const paragraphNode = document.createElement('p');
    paragraphNode.setAttribute('style', 'white-space: pre;');

    // ToDo: add 3s Event (WI:104964)

    // Sticky note content is already sanitized on server, but we sanitize it again to be safe.
    // tslint:disable-next-line:no-inner-html
    paragraphNode.innerHTML = HtmlSanitizer.sanitizeHtml(sonoraItem.body);
    insertNodeCallback(paragraphNode);
};

const getModifiedTime = (sonoraItem: SonoraStickyNotes): string => {
    const { dateTimeLastModifiedUTC } = sonoraItem;
    const date: OwaDate = owaDate('UTC', dateTimeLastModifiedUTC);
    const relativeDate = formatPastRelativeDateTime(date, observableNow());
    return format(loc(SonoraStickyNotesLastModifiedTimeLabel), relativeDate);
};
